import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Assessment as AssessmentIcon } from "@mui/icons-material";
import { GlobalBox } from "components/Box/GlobalBox";
import { TableInputs } from "components/CardTable/TableInputs";
import { newDate } from "helpers/dateTools";
import { dateValidator } from "helpers/dateValidator";
import { MAX_DATE_RANGE_DAYS } from "helpers/dictionary";
import { useSearch } from "hooks/useSearch";
import {
  setTransferInvoiceReportFilters,
  getTransferInvoiceReportAction,
} from "redux/actions/Reports/reportTransferInvoice/reportTransferInvoiceActions";
import { TRANSFER_INVOICE_REPORT_LOADINGS } from "redux/reducers/Reports/reportTransferInvoice/types";

export const ReportTransferInvoiceView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const isLoadingComp = useSelector(({ search }) => search.isLoadingComp);
  const { startDate, endDate, station } = useSelector((state) => state.reportTransferInvoice);

  const loading = isLoadingComp?.[TRANSFER_INVOICE_REPORT_LOADINGS.GET_REPORT] ?? false;

  const handleSubmit = (isPdf) => {
    if (!station?.id) {
      setSnackbar("Falta seleccionar planta.", "warning");
      return;
    }
    if (dateValidator(startDate, endDate, MAX_DATE_RANGE_DAYS, setSnackbar)) return;
    dispatch(getTransferInvoiceReportAction({ startDate, endDate, station, isPdf }));
  };

  return (
    <GlobalBox title="Reporte de Facturas de Traslado" icon={<AssessmentIcon />}>
      <TableInputs
        reducer="reportTransferInvoice"
        dates
        stations
        maxDate={newDate()}
        dispatchAction={setTransferInvoiceReportFilters}
        submitAction={() => handleSubmit(true)}
        submitButtonName="PDF"
        submitSecond={() => handleSubmit(false)}
        loading={loading}
      />
    </GlobalBox>
  );
};
